export default "__VITE_ASSET__DR_Qggp9__"